import { useInputState } from './useInputState';

export function useUnitNumberInputState(options) {
  return useInputState({
    initialValue: '',
    ...(options || {})
  });
}
